import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { Typography } from '@/components/Typography';
import { FilterDrawer } from '@/components/blocks/cms/FilteredFleetTypeCardsBlock/FilterDrawer';
import { FilterDrawerTrigger } from '@/components/blocks/cms/FilteredFleetTypeCardsBlock/FilterDrawerTrigger';
import { FilterDropdown } from '@/components/blocks/cms/FilteredFleetTypeCardsBlock/FilterDropdown';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import type { FilterProps } from './types';
export interface FiltersProps {
  clearAll: () => void;
  filters: FilterProps[];
  itemCount: number;
  maxItems: number;
}
export function Filters(t0) {
  const $ = _c(6);
  const {
    clearAll,
    filters,
    itemCount,
    maxItems
  } = t0;
  const drawerId = `drawer-filters-${useId()}`;
  let t1;
  if ($[0] !== clearAll || $[1] !== drawerId || $[2] !== filters || $[3] !== itemCount || $[4] !== maxItems) {
    t1 = filters.length > 0 ? <><div className="sticky top-0 bg-white z-10"><div className="flex gap-4 px-0 py-6 justify-between items-center card-shadow-b !w-full"><button className="hidden md:block btn btn-primary btn-outline pl-8 pr-7 border-primary h-13" onClick={clearAll}>Clear filters</button><label htmlFor={drawerId} className="md:hidden btn bg-white text-primary pl-8 pr-7 border-primary h-13 drawer-button">Show filters</label><div className="gap-4 hidden md:flex">{filters.map(_temp)}</div><span>Showing {itemCount}/{maxItems}</span></div></div><div className="drawer bg-white z-101 md:hidden"><input id={drawerId} type="checkbox" className="drawer-toggle" aria-label="Toggle filters" /><div className="drawer-side min-h-full"><label htmlFor={drawerId} aria-label="close sidebar" className="drawer-overlay" /><div className="bg-white h-full w-[94vw] flex flex-col"><div className="border-b-1 border-base-300 px-6 py-4 flex flex-row justify-between items-center"><Typography variant="h6" className="grow text-left text-nowrap">Filter by</Typography><label className="leading-none" htmlFor={drawerId} aria-label="close sidebar"><PhosphorIcon className="text-[24px]" name="x" /></label></div><div className="px-6 py-8 flex flex-col gap-8 grow">{filters.map(_temp2)}</div><div className="flex justify-center px-6 py-4 bg-white w-full"><button className="btn bg-white text-primary pl-8 pr-7 border-primary h-13" onClick={clearAll}>Clear all</button></div></div></div></div>{filters.map(props_1 => <FilterDrawer key={props_1.title} topDrawerId={drawerId} {...props_1} />)}</> : null;
    $[0] = clearAll;
    $[1] = drawerId;
    $[2] = filters;
    $[3] = itemCount;
    $[4] = maxItems;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function _temp2(props_0) {
  return <FilterDrawerTrigger key={props_0.title} title={props_0.title} />;
}
function _temp(props) {
  return <FilterDropdown key={props.title} {...props} />;
}